import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedProducts from './components/FeaturedProducts';
import VideoSection from './components/VideoSection';
import NewsletterSection from './components/NewsletterSection';
import StatsSection from './components/StatsSection';
import { setPageJsonLd, removePageJsonLd } from '../../utils/jsonLd';

export default function HomePage() {
  useEffect(() => {
    document.title = 'Off-Grid Living & Camping Gear Reviews | Shocker Solutions';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Expert reviews and real-world testing of solar generators, off-grid refrigeration, and camping gear. Honest recommendations for Jackery, SetPower, and outdoor equipment that works when you\'re miles from civilization.');
    }

    const canonicalLink = document.querySelector('link[rel="canonical"]');
    if (canonicalLink) {
      canonicalLink.setAttribute('href', 'https://www.shockersolutions.com/');
    }

    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://www.shockersolutions.com';

    setPageJsonLd({
      '@context': 'https://schema.org',
      '@graph': [
        {
          '@type': 'WebPage',
          '@id': `${siteUrl}/#webpage`,
          url: `${siteUrl}/`,
          name: 'Off-Grid Living & Camping Gear Reviews | Shocker Solutions',
          description: 'Expert reviews and real-world testing of solar generators, off-grid refrigeration, and camping gear. Honest recommendations for Jackery, SetPower, and outdoor equipment.',
          isPartOf: { '@id': `${siteUrl}/#website` },
          dateModified: '2025-01-01',
        },
        {
          '@type': 'Organization',
          '@id': `${siteUrl}/#organization`,
          name: 'Shocker Solutions',
          url: siteUrl,
          description: 'Expert off-grid living and camping gear reviews based on real-world testing.',
          contactPoint: {
            '@type': 'ContactPoint',
            contactType: 'customer support',
            email: 'info@shockersolutions.com',
          },
        },
      ],
    });

    return () => removePageJsonLd();
  }, []);

  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedProducts />
        <VideoSection />
        <NewsletterSection />
        <StatsSection />
      </main>
      <Footer />
    </div>
  );
}
